module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_1.0cd21f1e.png";